import moment from 'moment';

(function init() {
  angular.module('app').controller('host.views.debugTools.triggerHubPolicySearch.modal', [
    '$uibModalInstance',
    'abp.services.app.debugTool',
    function controller($uibModalInstance, debugToolSvc) {
      const vm = this;
      vm.saving = 0;
      vm.policies = null;
      // Two-page modal: 'form' collects the payload, 'result' replaces it with the
      // Hub response; Back returns to the form with the entered values intact.
      vm.view = 'form';

      vm.identifierType = '';
      vm.identifierValue = '';
      vm.benefitCategory = '';
      vm.visitType = '';
      vm.providerId = '';
      vm.birthDate = null;

      vm.identifierTypeOptions = [
        'PassportNumber',
        'NationalId',
        'PolicyNumber',
        'CardNumber',
        'BeneficiaryName',
      ];
      vm.benefitCategoryOptions = [
        'Hospitalization',
        'Maternity',
        'Gp',
        'Dental',
        'Optical',
        'OutpatientSpecialist',
        'MedicalScreening',
        'Pharmacy',
      ];
      vm.visitTypeOptions = ['Inpatient', 'Outpatient'];

      // singleDatePicker mode binds the model as a bare moment (see the vendored
      // angular-daterangepicker wrapper), so models are read directly, not via .startDate.
      // Required timestamps default to now; the plugin only fires its callback when the
      // selection changes, so an empty field plus "pick today" would otherwise commit nothing.
      vm.datePickerOptions = {
        singleDatePicker: true,
        locale: {
          format: 'L',
          applyLabel: App.localize('Apply'),
          cancelLabel: App.localize('Cancel'),
        },
      };
      vm.dateTimePickerOptions = {
        singleDatePicker: true,
        timePicker: true,
        timePicker24Hour: true,
        locale: {
          format: 'L LT',
          applyLabel: App.localize('Apply'),
          cancelLabel: App.localize('Cancel'),
        },
      };

      vm.cancel = cancel;
      vm.execute = execute;
      vm.back = back;
      vm.clearBirthDate = clearBirthDate;
      vm.plainText = plainText;
      vm.formatPeriod = formatPeriod;

      function back() {
        vm.view = 'form';
      }

      // Some Hub fields (e.g. productRemark) carry HTML; show them as readable text.
      function plainText(value) {
        if (value === null || value === undefined) return '';
        return String(value)
          .replace(/<[^>]*>/g, ' ')
          .replace(/&nbsp;/g, ' ')
          .replace(/&amp;/g, '&')
          .replace(/\s+/g, ' ')
          .trim();
      }

      function formatPeriod(period) {
        if (!period) return '';
        const from = period.startDate ? moment(period.startDate).format('YYYY-MM-DD') : '';
        const to = period.endDate ? moment(period.endDate).format('YYYY-MM-DD') : '';
        if (!from && !to) return '';
        return `${from || '—'} to ${to || '—'}`;
      }

      function cancel() {
        $uibModalInstance.dismiss();
      }

      function clearBirthDate() {
        vm.birthDate = null;
      }

      function execute() {
        if (!App.isFormValid(vm.triggerHubPolicySearchForm)) return;

        const input = {
          identifierValue: vm.identifierValue,
          benefitCategory: vm.benefitCategory,
          visitType: vm.visitType,
        };
        if (vm.identifierType) input.identifierType = vm.identifierType;
        if (vm.providerId) input.providerId = vm.providerId;
        if (vm.birthDate) input.birthDate = moment(vm.birthDate).format('YYYY-MM-DD');

        vm.saving += 1;
        vm.policies = null;
        debugToolSvc
          .triggerHubPolicySearch(input)
          .success((result) => {
            // Kept raw so every field the Hub returns stays visible in the rendered view.
            vm.policies = result || [];
            vm.view = 'result';
            abp.notify.info(`Hub returned ${vm.policies.length} policy(ies).`);
          })
          .finally(() => {
            vm.saving -= 1;
          });
      }
    },
  ]);
})();
